import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { SpecialCompbaser } from "../../../components/compbaser";
import { Router } from "@angular/router";
import { LocalStoreService, StoreSelectorsService } from "../../../services";
import { ICategoryCheckItemNode, ICategoryTreeSelection } from "../../../components/category-tree/tree-service/tree-data.model";
import { CategoryTreeComponent } from "../../../components/category-tree/category-tree.component";
import { actionGetResourcesSharedLibrary, actionGetResourcesSharedLibrarySuccess, actionGetSharedCommonContent, actionGetSharedCommonContentReply } from "../../../store/actions/user.actions";
import { IResourceSharedItem, ISharedContent } from "../../../interfaces";
import { appData, isHostDev, SUPPORTED_FILE_TYPES } from "../../../common";
import { Lib } from "../../../../libs/Lib";
import { ActionsSubject } from "@ngrx/store";
import { ofType } from "@ngrx/effects";
import * as _ from "lodash";

@Component({
    selector: "app-create-resource",
    templateUrl: "./create-resource.component.html",
    styleUrls: ["./create-resource.component.scss"],
    standalone: false
})
export class CreateResourceComponent extends SpecialCompbaser implements OnInit {
    @ViewChild("treeCategory") treeCategory: CategoryTreeComponent;

    @Input() dialogGetAsset;
    @Output() itemSelected = new EventEmitter<string>();

    resourceData: Array<IResourceSharedItem> = [];
    resourceDataEnterprise: Array<IResourceSharedItem>;
    sharedResources: Array<IResourceSharedItem> = [];
    sharedResourcesEnterprise: Array<IResourceSharedItem> = [];
    categoryTreeItems: Array<ICategoryCheckItemNode> = [];
    enterprise = false;
    isUpdatingEnterprise = false;
    importType: string;
    sharedContentTreeItems: Array<ICategoryCheckItemNode>;

    constructor(private storeSelector: StoreSelectorsService, private router: Router, private localStore: LocalStoreService, private actionsSubj: ActionsSubject) {
        super();
        this.setMe("create-resource.component.ts");
        this.categoryTreeItems = [];
        this.getResourcesLibrary();
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                this.enterprise = Lib.GetAccountVersion(user) === "ENTERPRISE_08" || Lib.GetAccountVersion(user) === "ENTERPRISE_24";
            }),
        );
    }

    ngOnInit(): void {
        this.cod(
            this.storeSelector.getResourceSharedLibrary().subscribe((v) => {
                this.localStore.setStorageSharedLibrary(v);
                if (!v.library) return;
                this.sharedResources = v.library;
                this.buildResourceTree();
            }),
        );
        this.cod(
            this.actionsSubj.pipe(ofType(actionGetSharedCommonContentReply)).subscribe((reply: any) => {
                const i_sharedContents: ISharedContent[] = reply.value;
                this.isUpdatingEnterprise = false;
                if (i_sharedContents?.length > 0) {
                    this.sharedResourcesEnterprise = [];
                    i_sharedContents.forEach((item) => {
                        const sceneContent = item.data?.resources;
                        if (sceneContent?.length > 0) {
                            sceneContent.forEach((row) => {
                                if (SUPPORTED_FILE_TYPES.indexOf(row.type.toLowerCase()) === -1) return;
                                this.sharedResourcesEnterprise.push({
                                    $: {
                                        businessId: row.businessId + "",
                                        resourceId: row.resourceId + "",
                                        resourceType: row.type,
                                        resourceName: row.name,
                                        treePath: row.path,
                                        defaultPlayer: "",
                                    },
                                    url: `${appData.cloudResourcesS3}/business${row.businessId}/resources/${row.resourceId}.${row.type}`,
                                });
                            });
                        }
                    });
                    this.buildSharedContentTree();
                    this.resourceDataEnterprise = this.sharedResourcesEnterprise;
                }
            }),
        );
    }

    redirectTo(uri: string) {
        window.stop();
        setTimeout(() => {
            this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => this.router.navigate([uri]));
        }, 50);
    }

    getEnterpriseSharedContent() {
        if (this.isUpdatingEnterprise) return;
        this.isUpdatingEnterprise = true;
        return this.storeSelector.dispatch(actionGetSharedCommonContent({ config: null }));
    }

    private buildResourceTree() {
        this.categoryTreeItems = [];
        const uniqueTreepaths = [];
        this.sharedResources.forEach((res) => {
            if (SUPPORTED_FILE_TYPES.indexOf(res.$.resourceType.toLowerCase()) === -1) return;
            const treePath = res.$.treePath;
            if (!treePath) return;
            if (!uniqueTreepaths.includes(treePath)) {
                uniqueTreepaths.push(treePath);
            }
        });
        this.categoryTreeItems = uniqueTreepaths.map((path) => ({
            id: _.uniqueId("__"),
            item: path,
            children: [],
            selected: false,
        }));

        this.categoryTreeItems = this.categoryTreeItems.sort((a, b) => {
            if (a.item > b.item) return 1;
            if (b.item > a.item) return -1;
            return 0;
        });
    }

    private getResourcesLibrary() {
        const lib = this.localStore.getSharedResourceLibrary();
        if (lib && !Lib.DevMode() && !isHostDev()) {
            return this.storeSelector.dispatch(actionGetResourcesSharedLibrarySuccess({ value: lib }));
        }
        console.log("getting fresh shared library resources...");
        this.storeSelector.dispatch(
            actionGetResourcesSharedLibrary({
                config: {
                    "ida.signage.me": [],
                },
            }),
        );
        // add in the future: automate business domain for users
        // this.storeSelector
        //     .getBusinessesByDomain()
        //     .pipe(take(1))
        //     .subscribe((businessDomains) => {
        //         this.storeSelector.dispatch(actionGetResourcesLibrary(businessDomains));
        //     });
    }

    onUpdateTree(categoryTreeSelection: ICategoryTreeSelection) {
        if (categoryTreeSelection.checklist.length === 0) return (this.resourceData = null);
        const selectedPath = [];
        categoryTreeSelection.checklist.forEach((v) => {
            if (!v.expandable) {
                selectedPath.push(v.item);
            }
        });
        this.resourceData = this.sharedResources.filter((r) => selectedPath.indexOf(r.$.treePath) > -1);
    }

    onItemSelected(resourceId) {
        if (this.itemSelected) {
            this.itemSelected.emit(resourceId);
        }
    }

    openGroup(panelType) {
        this.importType = panelType;
        if (panelType == "shared") {
            if (!this.sharedResourcesEnterprise?.length) {
                return this.storeSelector.dispatch(actionGetSharedCommonContent({ config: null }));
            }
        }
    }

    private buildSharedContentTree() {
        const businessIds = [];
        this.sharedResourcesEnterprise.forEach((item) => {
            const businessId = item.$?.businessId;
            if (businessId) {
                if (!businessIds.includes(businessId)) {
                    businessIds.push(businessId);
                }
            }
        });

        this.sharedContentTreeItems = businessIds.map((_businessId) => ({
            id: _.uniqueId("__"),
            item: _businessId,
            children: [],
            selected: true,
        }));

        this.sharedContentTreeItems.sort((a, b) => {
            if (a.item > b.item) return 1;
            if (b.item > a.item) return -1;
            return 0;
        });
    }

    onUpdateShareContentTree(categoryTreeSelection: ICategoryTreeSelection) {
        if (categoryTreeSelection.checklist.length === 0) {
            this.resourceDataEnterprise = null;
            return;
        } 
        const selectedIds = [];
        categoryTreeSelection.checklist.forEach((v) => {
            if (!v.expandable) {
                selectedIds.push(v.item);
            }
        });
        this.resourceDataEnterprise = this.sharedResourcesEnterprise.filter((item) => selectedIds.includes(item.$.businessId));
    }
}
